import { EventEmitter } from '@angular/core';
import { Router } from "@angular/router";
import { TrackerService } from '../../../core/tracker/tracker.service';
import { UserService } from '../../../core/user/user.service';
import { NgbDropdown } from "@ng-bootstrap/ng-bootstrap";
import { LoginService } from '../../../core/login/login.service';
import { AccountService } from '../../../core/auth/account.service';
import * as i0 from "@angular/core";
import * as i1 from "../../../core/user/user.service";
import * as i2 from "@angular/router";
import * as i3 from "../../../core/tracker/tracker.service";
import * as i4 from "../../../core/login/login.service";
import * as i5 from "../../../core/auth/account.service";
import * as i6 from "@ng-bootstrap/ng-bootstrap";
import * as i7 from "@angular/common";
import * as i8 from "../../../ng-jhipster/language/jhi-translate.directive";
import * as i9 from "../../../shared/language/language-selector/language-selector.component";
import * as i10 from "../../../shared/auth/has-any-authority.directive";
import * as i11 from "../../../shared/upload-image-component/profile-image.component";
const _c0 = ["myDrop"];
function OrganizationDashboardNavbarComponent__svg_svg_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 16);
    i0.ɵɵelement(1, "use", 17);
    i0.ɵɵelementEnd();
} }
function OrganizationDashboardNavbarComponent__svg_svg_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 16);
    i0.ɵɵelement(1, "use", 18);
    i0.ɵɵelementEnd();
} }
function OrganizationDashboardNavbarComponent__svg_svg_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 16);
    i0.ɵɵelement(1, "use", 19);
    i0.ɵɵelementEnd();
} }
function OrganizationDashboardNavbarComponent__svg_svg_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 16);
    i0.ɵɵelement(1, "use", 20);
    i0.ɵɵelementEnd();
} }
function OrganizationDashboardNavbarComponent__svg_svg_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 16);
    i0.ɵɵelement(1, "use", 21);
    i0.ɵɵelementEnd();
} }
function OrganizationDashboardNavbarComponent__svg_svg_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 16);
    i0.ɵɵelement(1, "use", 22);
    i0.ɵɵelementEnd();
} }
function OrganizationDashboardNavbarComponent_div_21_div_11_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 44);
    i0.ɵɵelement(1, "profile-image", 45);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("coachId", ctx_r15.currentUser.id)("coachLogin", ctx_r15.currentUser.login)("doUpload", false)("size", 54);
} }
const _c1 = function () { return { "width": "200px" }; };
function OrganizationDashboardNavbarComponent_div_21_div_11_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 46, 47);
    i0.ɵɵlistener("mouseover", function OrganizationDashboardNavbarComponent_div_21_div_11_div_5_Template_div_mouseover_0_listener() { i0.ɵɵrestoreView(_r20); const _r18 = i0.ɵɵreference(1); const ctx_r19 = i0.ɵɵnextContext(3); return ctx_r19.checkOverflow(_r18) ? ctx_r19.showTooltip = true : ctx_r19.showTooltip = false; });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction0(2, _c1));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r16.currentUser.email, " ");
} }
function OrganizationDashboardNavbarComponent_div_21_div_11_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 48);
    i0.ɵɵlistener("mouseleave", function OrganizationDashboardNavbarComponent_div_21_div_11_div_6_Template_div_mouseleave_0_listener() { i0.ɵɵrestoreView(_r22); const ctx_r21 = i0.ɵɵnextContext(3); return ctx_r21.showTooltip = false; });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "slice");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "br");
    i0.ɵɵelementStart(5, "span");
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "slice");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind3(3, 2, ctx_r17.currentUser.email, 0, ctx_r17.currentUser.email.indexOf("@")));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind3(7, 6, ctx_r17.currentUser.email, ctx_r17.currentUser.email.indexOf("@"), ctx_r17.currentUser.email.length));
} }
const _c2 = function () { return ["ROLE_COACH"]; };
function OrganizationDashboardNavbarComponent_div_21_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 40);
    i0.ɵɵtemplate(1, OrganizationDashboardNavbarComponent_div_21_div_11_div_1_Template, 2, 4, "div", 41);
    i0.ɵɵelementStart(2, "div");
    i0.ɵɵelementStart(3, "h3");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, OrganizationDashboardNavbarComponent_div_21_div_11_div_5_Template, 3, 3, "div", 42);
    i0.ɵɵtemplate(6, OrganizationDashboardNavbarComponent_div_21_div_11_div_6_Template, 8, 10, "div", 43);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("jhiHasAnyAuthority", i0.ɵɵpureFunction0(4, _c2));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r14.currentUser.login);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r14.showTooltip);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r14.showTooltip);
} }
const _c3 = function (a0) { return { username: a0 }; };
const _c4 = function (a0) { return { "transform": a0 }; };
function OrganizationDashboardNavbarComponent_div_21_Template(rf, ctx) { if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 23, 24);
    i0.ɵɵelementStart(2, "div", 25);
    i0.ɵɵelementStart(3, "div", 26);
    i0.ɵɵelementStart(4, "span", 27);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "span", 28);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "button", 29);
    i0.ɵɵlistener("click", function OrganizationDashboardNavbarComponent_div_21_Template_button_click_7_listener() { i0.ɵɵrestoreView(_r24); const ctx_r23 = i0.ɵɵnextContext(); return ctx_r23.menuButtonClicked(); });
    i0.ɵɵelement(8, "img", 30);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "ul", 31);
    i0.ɵɵelement(10, "language-selector", 32);
    i0.ɵɵtemplate(11, OrganizationDashboardNavbarComponent_div_21_div_11_Template, 7, 5, "div", 33);
    i0.ɵɵelementStart(12, "div", 34);
    i0.ɵɵlistener("click", function OrganizationDashboardNavbarComponent_div_21_Template_div_click_12_listener() { i0.ɵɵrestoreView(_r24); const ctx_r25 = i0.ɵɵnextContext(); return ctx_r25.collapseDropdown(); });
    i0.ɵɵelementStart(13, "li");
    i0.ɵɵelement(14, "a", 35);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "li");
    i0.ɵɵelement(16, "a", 36);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "li");
    i0.ɵɵelement(18, "a", 37);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "li");
    i0.ɵɵelement(20, "a", 38);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "li");
    i0.ɵɵelementStart(22, "button", 39);
    i0.ɵɵlistener("click", function OrganizationDashboardNavbarComponent_div_21_Template_button_click_22_listener() { i0.ɵɵrestoreView(_r24); const ctx_r26 = i0.ɵɵnextContext(); return ctx_r26.logout(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r13 = i0.ɵɵreference(1);
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r6.currentUser.login[0]);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction1(6, _c3, ctx_r6.currentUser.login));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(8, _c4, _r13.isOpen() ? "rotate(90deg)" : "rotate(0deg)"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r6.currentUser != null);
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("routerLink", ctx_r6.organizationAdminRoute);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("routerLink", ctx_r6.settingsRoute);
} }
function OrganizationDashboardNavbarComponent__svg_svg_25_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 16);
    i0.ɵɵelement(1, "use", 17);
    i0.ɵɵelementEnd();
} }
function OrganizationDashboardNavbarComponent__svg_svg_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 16);
    i0.ɵɵelement(1, "use", 18);
    i0.ɵɵelementEnd();
} }
function OrganizationDashboardNavbarComponent__svg_svg_29_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 16);
    i0.ɵɵelement(1, "use", 19);
    i0.ɵɵelementEnd();
} }
function OrganizationDashboardNavbarComponent__svg_svg_30_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 16);
    i0.ɵɵelement(1, "use", 20);
    i0.ɵɵelementEnd();
} }
function OrganizationDashboardNavbarComponent__svg_svg_33_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 16);
    i0.ɵɵelement(1, "use", 21);
    i0.ɵɵelementEnd();
} }
function OrganizationDashboardNavbarComponent__svg_svg_34_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 16);
    i0.ɵɵelement(1, "use", 22);
    i0.ɵɵelementEnd();
} }
export class OrganizationDashboardNavbarComponent {
    constructor(userService, router, trackerService, loginService, accountService) {
        this.userService = userService;
        this.router = router;
        this.trackerService = trackerService;
        this.loginService = loginService;
        this.accountService = accountService;
        this.onTabChange = new EventEmitter();
        this.selectedTab = 'overview';
        this.showTooltip = false;
    }
    ngOnInit() {
        this.organizationAdminRoute = this.router.routerState.snapshot.url;
        this.settingsRoute = '/user-settings';
        this.getCurrentUser();
    }
    getCurrentUser() {
        this.userService.current().subscribe(currentUser => {
            this.currentUser = currentUser;
            console.log(this.currentUser);
        });
    }
    switchToTab(tab) {
        this.selectedTab = tab;
        this.onTabChange.emit(this.selectedTab);
    }
    getTabColor(tab) {
        let result = '';
        if (this.selectedTab === tab)
            result = 'page-tab-selected';
        return result;
    }
    menuButtonClicked() {
        if (this.organizationAdminRoute.includes("/organization-dashboard-index/")) {
            this.trackerService.sendActivity('organization_dashboard_index_menu_btn_clicked');
        }
        else {
            console.log("URL not recognized: " + this.organizationAdminRoute);
        }
    }
    checkOverflow(element) {
        return element.offsetHeight < element.scrollHeight || element.offsetWidth < element.scrollWidth;
    }
    collapseDropdown() {
        this.myDrop.close();
    }
    logout() {
        this.collapseDropdown();
        this.loginService.logout();
        this.router.navigate(['']).then();
        this.accountService.clearCookies();
    }
}
OrganizationDashboardNavbarComponent.ɵfac = function OrganizationDashboardNavbarComponent_Factory(t) { return new (t || OrganizationDashboardNavbarComponent)(i0.ɵɵdirectiveInject(i1.UserService), i0.ɵɵdirectiveInject(i2.Router), i0.ɵɵdirectiveInject(i3.TrackerService), i0.ɵɵdirectiveInject(i4.LoginService), i0.ɵɵdirectiveInject(i5.AccountService)); };
OrganizationDashboardNavbarComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: OrganizationDashboardNavbarComponent, selectors: [["organization-dashboard-navbar"]], viewQuery: function OrganizationDashboardNavbarComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.myDrop = _t.first);
    } }, outputs: { onTabChange: "onTabChange" }, decls: 36, vars: 19, consts: [[1, "olha-theme", 2, "font-size", "1rem"], ["id", "page-navbar", 1, "navbar", "navbar-dark", "d-flex", "align-items-center", 2, "height", "60px"], [1, "d-flex", "align-items-between", "left-side-margin"], [2, "width", "5.2rem!important", "height", "2.2rem!important"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#inuka-logo-left"], [1, "d-none", "d-lg-block"], [1, "btn", "page-tab", 3, "ngClass", "click"], ["class", "mr-1", "style", "width:18px!important; height:18px!important", 4, "ngIf"], ["jhiTranslate", "inukaNgApp.organizationAdmin.organizationAdminNavbar.overview"], ["jhiTranslate", "inukaNgApp.organizationAdmin.organizationAdminNavbar.wellbeing"], ["jhiTranslate", "inukaNgApp.organizationAdmin.organizationAdminNavbar.insights"], [1, "d-flex", "justify-content-end", "align-items-center"], [1, "ml-3", "mr-3", "d-none", "d-md-block", "d-lg-block", "d-xl-block"], ["class", "ml-3 d-inline-block text-dark align-middle right-side-margin", "ngbDropdown", "", 4, "ngIf"], [1, "d-lg-none", 2, "margin-top", "60px", "background", "white"], [1, "d-flex", "align-items-center", "justify-content-around"], [1, "mr-1", 2, "width", "18px!important", "height", "18px!important"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#chart-simple-white"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#chart-simple-grey"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#heart-white"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#heart-grey"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#book-open-white"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#book-open-grey"], ["ngbDropdown", "", 1, "ml-3", "d-inline-block", "text-dark", "align-middle", "right-side-margin"], ["myDrop", "ngbDropdown"], [1, "d-flex", "justify-content-between", "align-items-center"], [1, "greeting-div", "d-flex", "justify-content-start", "align-items-center"], [1, "first-letter"], ["jhiTranslate", "inukaNgApp.organizationAdmin.organizationAdminNavbar.hi", 1, "greeting", 3, "translateValues"], ["ngbDropdownToggle", "", "id", "navbar-dropdown-button", 1, "navbar-toggler", 3, "click"], ["src", "../../../../../content/images/inuka/hamburger-medium.png", "alt", "hamburger-medium image", 1, "navbar-dropdown-hamburger", 2, "transform", "rotate(90deg)", 3, "ngStyle"], ["ngbDropdownMenu", "", 1, "collapse", "dropdown-menu", "dropdown-menu-right", "dropdown-menu-location"], [1, "ml-3", "mr-3", "d-md-none", "language-selector"], ["class", "d-flex justify-content-between align-items-center identification", 4, "ngIf"], [3, "click"], ["jhiTranslate", "global.menu.home", 3, "routerLink"], ["jhiTranslate", "global.menu.profile", 3, "routerLink"], ["routerLink", "/session/inbox/all", "jhiTranslate", "global.menu.customerCare"], ["routerLink", "/organization-selection", "jhiTranslate", "inukaNgApp.organizationAdmin.organizationAdminNavbar.switchAccount"], ["jhiTranslate", "global.menu.logOut", 1, "btn", "btn-secondary", 3, "click"], [1, "d-flex", "justify-content-between", "align-items-center", "identification"], ["class", "profile-icon", 4, "jhiHasAnyAuthority"], ["class", "overflow", 3, "ngStyle", "mouseover", 4, "ngIf"], ["class", "overflow-tool-tip", 3, "mouseleave", 4, "ngIf"], [1, "profile-icon"], [3, "coachId", "coachLogin", "doUpload", "size"], [1, "overflow", 3, "ngStyle", "mouseover"], ["overflow", ""], [1, "overflow-tool-tip", 3, "mouseleave"]], template: function OrganizationDashboardNavbarComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "nav", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div");
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(4, "svg", 3);
        i0.ɵɵelement(5, "use", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(6, "div", 5);
        i0.ɵɵelementStart(7, "div", 6);
        i0.ɵɵlistener("click", function OrganizationDashboardNavbarComponent_Template_div_click_7_listener() { return ctx.switchToTab("overview"); });
        i0.ɵɵtemplate(8, OrganizationDashboardNavbarComponent__svg_svg_8_Template, 2, 0, "svg", 7);
        i0.ɵɵtemplate(9, OrganizationDashboardNavbarComponent__svg_svg_9_Template, 2, 0, "svg", 7);
        i0.ɵɵelement(10, "span", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "div", 6);
        i0.ɵɵlistener("click", function OrganizationDashboardNavbarComponent_Template_div_click_11_listener() { return ctx.switchToTab("wellbeing"); });
        i0.ɵɵtemplate(12, OrganizationDashboardNavbarComponent__svg_svg_12_Template, 2, 0, "svg", 7);
        i0.ɵɵtemplate(13, OrganizationDashboardNavbarComponent__svg_svg_13_Template, 2, 0, "svg", 7);
        i0.ɵɵelement(14, "span", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(15, "div", 6);
        i0.ɵɵlistener("click", function OrganizationDashboardNavbarComponent_Template_div_click_15_listener() { return ctx.switchToTab("insights"); });
        i0.ɵɵtemplate(16, OrganizationDashboardNavbarComponent__svg_svg_16_Template, 2, 0, "svg", 7);
        i0.ɵɵtemplate(17, OrganizationDashboardNavbarComponent__svg_svg_17_Template, 2, 0, "svg", 7);
        i0.ɵɵelement(18, "span", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(19, "div", 11);
        i0.ɵɵelement(20, "language-selector", 12);
        i0.ɵɵtemplate(21, OrganizationDashboardNavbarComponent_div_21_Template, 23, 10, "div", 13);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(22, "div", 14);
        i0.ɵɵelementStart(23, "div", 15);
        i0.ɵɵelementStart(24, "div", 6);
        i0.ɵɵlistener("click", function OrganizationDashboardNavbarComponent_Template_div_click_24_listener() { return ctx.switchToTab("overview"); });
        i0.ɵɵtemplate(25, OrganizationDashboardNavbarComponent__svg_svg_25_Template, 2, 0, "svg", 7);
        i0.ɵɵtemplate(26, OrganizationDashboardNavbarComponent__svg_svg_26_Template, 2, 0, "svg", 7);
        i0.ɵɵelement(27, "span", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(28, "div", 6);
        i0.ɵɵlistener("click", function OrganizationDashboardNavbarComponent_Template_div_click_28_listener() { return ctx.switchToTab("wellbeing"); });
        i0.ɵɵtemplate(29, OrganizationDashboardNavbarComponent__svg_svg_29_Template, 2, 0, "svg", 7);
        i0.ɵɵtemplate(30, OrganizationDashboardNavbarComponent__svg_svg_30_Template, 2, 0, "svg", 7);
        i0.ɵɵelement(31, "span", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(32, "div", 6);
        i0.ɵɵlistener("click", function OrganizationDashboardNavbarComponent_Template_div_click_32_listener() { return ctx.switchToTab("insights"); });
        i0.ɵɵtemplate(33, OrganizationDashboardNavbarComponent__svg_svg_33_Template, 2, 0, "svg", 7);
        i0.ɵɵtemplate(34, OrganizationDashboardNavbarComponent__svg_svg_34_Template, 2, 0, "svg", 7);
        i0.ɵɵelement(35, "span", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("ngClass", ctx.getTabColor("overview"));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.selectedTab === "overview");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.selectedTab !== "overview");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", ctx.getTabColor("wellbeing"));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.selectedTab === "wellbeing");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.selectedTab !== "wellbeing");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", ctx.getTabColor("insights"));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.selectedTab === "insights");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.selectedTab !== "insights");
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.currentUser);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngClass", ctx.getTabColor("overview"));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.selectedTab === "overview");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.selectedTab !== "overview");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", ctx.getTabColor("wellbeing"));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.selectedTab === "wellbeing");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.selectedTab !== "wellbeing");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", ctx.getTabColor("insights"));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.selectedTab === "insights");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.selectedTab !== "insights");
    } }, directives: [i6.NgbNavbar, i7.NgClass, i7.NgIf, i8.JhiTranslateDirective, i9.LanguageSelectorComponent, i6.NgbDropdown, i6.NgbDropdownToggle, i7.NgStyle, i6.NgbDropdownMenu, i2.RouterLinkWithHref, i10.HasAnyAuthorityDirective, i11.ProfileImageComponent], pipes: [i7.SlicePipe], styles: ["html[_ngcontent-%COMP%]{scroll-behavior:smooth}.page-tab[_ngcontent-%COMP%]{border-radius:28px;cursor:pointer;border:1px solid #fff;color:#9db7b0;width:150px !important}.page-tab-selected[_ngcontent-%COMP%]{background:#44a38b;color:#fff}.badge-rounded-purple-text[_ngcontent-%COMP%]{position:absolute;width:100%;text-align:center}.badge-rounded-purple[_ngcontent-%COMP%]{position:relative;border-radius:50%;height:1.5rem;width:1.5rem;background-color:#9e6a8f;color:#fff;font-size:medium;font-weight:700;text-align:center;text-decoration:none;white-space:nowrap;transition:color .15s ease-in-out}.greeting[_ngcontent-%COMP%]{color:#0a4a3a;font-family:\"Open Sans\",serif;font-size:14px;font-style:normal;font-weight:400;line-height:140%;margin:0 15px 0 15px}.first-letter[_ngcontent-%COMP%]{display:inline-flex;height:24px;width:24px;padding:10px;justify-content:center;align-items:center;gap:10px;flex-shrink:0;border-radius:50%;background:#44a38b;color:#fff !important;text-align:center;font-feature-settings:\"clig\" off,\"liga\" off;font-family:\"Open Sans\",serif;font-size:18px !important;font-style:normal;font-weight:400;line-height:140%}.navbar-toggler[_ngcontent-%COMP%], .navbar-dropdown-hamburger[_ngcontent-%COMP%]{padding:0 !important;transition:all .3s}#navbarToggleExternalContent[_ngcontent-%COMP%]{background-color:#fff !important;z-index:500;margin-top:60px}.navbar-dropdown-list[_ngcontent-%COMP%]{font-weight:bold;font-size:20px;text-align:center}.navbar-dropdown-list[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{margin-bottom:5px}.navbar-dropdown-list[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#000 !important;text-decoration:none;text-transform:uppercase}.dropdown-menu[_ngcontent-%COMP%]{background:#f8f7f2;width:360px;padding:70px 5px 70px 70px;height:100%;border:none;box-shadow:-3px 0px 30px rgba(0,0,0,.15)}.dropdown-menu-location[_ngcontent-%COMP%]{position:fixed;top:58px !important;right:0;overflow:scroll}.dropdown-toggle[_ngcontent-%COMP%]:after{display:none !important}.overflow[_ngcontent-%COMP%]{text-overflow:ellipsis;-ms-text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.overflow-tool-tip[_ngcontent-%COMP%]{width:200px}.hamburger-message-indicator[_ngcontent-%COMP%]{font-size:.5rem}h3[_ngcontent-%COMP%]{margin-bottom:0}.identification[_ngcontent-%COMP%]{margin-bottom:40px}.first-letter[_ngcontent-%COMP%]{font-size:40px;font-weight:900 !important;color:#44a38b}.language-selector[_ngcontent-%COMP%]{position:fixed;top:90px;right:20px}li[_ngcontent-%COMP%]{margin-bottom:30px;font-weight:bold}.left-side-margin[_ngcontent-%COMP%]{margin-left:20px !important}.right-side-margin[_ngcontent-%COMP%]{margin-right:20px !important}#page-navbar[_ngcontent-%COMP%]{box-shadow:none;background:#fff !important}.profile-icon[_ngcontent-%COMP%]{margin-right:10px}@media(min-width: 576px){.badge-rounded-purple[_ngcontent-%COMP%], .hamburger-message-indicator[_ngcontent-%COMP%]{font-size:.6rem}.language-selector[_ngcontent-%COMP%]{font-size:.9rem}}@media(min-width: 768px){.badge-rounded-purple[_ngcontent-%COMP%], .hamburger-message-indicator[_ngcontent-%COMP%]{font-size:.7rem}.language-selector[_ngcontent-%COMP%]{font-size:1rem}.left-side-margin[_ngcontent-%COMP%]{margin-left:84px !important}.right-side-margin[_ngcontent-%COMP%]{margin-right:84px !important}}@media(min-width: 992px){.badge-rounded-purple[_ngcontent-%COMP%], .hamburger-message-indicator[_ngcontent-%COMP%]{font-size:.8rem}.language-selector[_ngcontent-%COMP%]{font-size:1.1rem}}"] });
